(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mgr-gift-presentation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
const button=event.target.closest('.mgr-gift-product__pause');
if(!button)return;
const paused=button.getAttribute('aria-pressed')!=='true';
button.setAttribute('aria-pressed',String(paused));
button.textContent=paused?'▶':'Ⅱ';
button.closest('.mgr-gift-product').classList.toggle('is-paused',paused);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mgr-shop-motion"] && !Shopify.designMode) return;
  try {
    function mgrInitShopMotion(){
document.querySelectorAll('[data-mgr-shop-toggle]:not([data-ready])').forEach(button=>{
button.dataset.ready='true';
const area=button.closest('.mgr-screen--shop');
button.addEventListener('click',()=>{
const paused=button.getAttribute('aria-pressed')!=='true';
button.setAttribute('aria-pressed',String(paused));
button.setAttribute('aria-label',paused?button.dataset.play:button.dataset.pause);
button.textContent=paused?'▶':'Ⅱ';
area.classList.toggle('mgr-shop-motion-is-paused',paused);
});
if('IntersectionObserver' in window)new IntersectionObserver(entries=>entries.forEach(entry=>area.classList.toggle('mgr-shop-motion-offscreen',!entry.isIntersecting)),{threshold:0}).observe(area);
});
}
mgrInitShopMotion();
document.addEventListener('shopify:section:load',mgrInitShopMotion);
  } catch(e) { console.error(e); }
})();

})();
